<template>
    <!--首頁Banner輪播css-->
    <div class="bannerall">
        <div class="htmleaf-content">
            <div id="posterTvGrid" name="posterTvGrid" class="posterTvGrid" style="margin: 40px auto 0 auto;"></div>
        </div>
    </div>
</template>
<script>
    
    export default{
        components:{

        },
        data(){
            return{
                //輪播圖總數
                totalCount:0,
                bannerImgs:[/*{
                    "img":"", // 圖片位置
                    "title":"", // 標題
                    "url": "",// 連結網址
                }*/],
            };
        },
        props:["banner"],
        mounted(){
            //初始化
            this.init();
            //this.BannerInit();
        },
        watch:{
            /*bannerImgs(){
                this.BannerInit();
            }*/
        },
        methods:{
            //初始化
            async init() {
                await this.getBanner();
            },
            //取得廣告輪播圖
            async getBanner(){
                try{
                    //POST 參數
                    let jsonReq={
                        TYPE:"HOME_LIST",
                        banner_SELECT:{
                            langurage:1,
                        }
                    };
                    //Token
                    let resToken = await this.userRequest.post("bicd/Token");
                    jsonReq.Token = resToken.data;
                    //執行API功能
                    let res =await this.userRequest.post("bicd/Banner",jsonReq);
                    //讀取資料
                    let json= JSON.parse(res.data);
                    if(json.Status){
                        let jsonData = JSON.parse(json.Data);
                        jsonData.forEach((x) => {
                            var obj = {
                                "img":"/filestore"+x.filePath, 
                                "title":x.title, 
                                "url": x.url? x.url:"#",
                            }
                            this.bannerImgs.push(obj);
                        });
                        this.BannerInit();
                    }
                }catch(err){
                    console.log("ErrFunction: getBanner/n "+err);
                }
            },
            BannerInit(){
                //載入首頁Banner輪播JS
                const script = document.createElement("script");
                script.setAttribute('nonce', 'SHhzTzNmaWIxZjZJWmVsRg==');
                script.src = "/js/posterTvGrid.js?v=1.3";
                script.onload =() => {
                    //將圖片資料匯入進到輪播圖內，僅需將img資料匯入到 imgData內
                    new posterTvGrid('posterTvGrid',{className: "posterTvGrid"},this.bannerImgs
                        /*[
                            {"img":"images\/1.jpg","title":"Lorem ipsum dolor sit amet","url":"#"},
                            {"img":"images\/2.jpg","title":"Lorem ipsum dolor sit amet","url":"#"},
                            {"img":"images\/3.jpg","title":"Lorem ipsum dolor sit amet","url":"#"},
                            {"img":"images\/4.jpg","title":"Lorem ipsum dolor sit amet","url":"#"},
                            {"img":"images\/5.jpg","title":"Lorem ipsum dolor sit amet","url":"#"}
                        ]*/
                    );
                };
                document.body.appendChild(script);
                //載入Banner輪播css樣式
                const link = document.createElement("link");
                link.rel = "stylesheet";
                link.type = "text/css";
                link.href = "/css/posterTvGrid.css"; // CSS 檔路徑
                document.head.appendChild(link);
            },
        }
    }
</script>